import { render, staticRenderFns } from "./CheckpointSettings.vue?vue&type=template&id=4389b1f3&scoped=true"
import script from "./CheckpointSettings.vue?vue&type=script&lang=js"
export * from "./CheckpointSettings.vue?vue&type=script&lang=js"
import style0 from "./CheckpointSettings.vue?vue&type=style&index=0&id=4389b1f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4389b1f3",
  null
  
)

export default component.exports